
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from 'clsx';
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { TextField } from "@mui/material";
import { Row, Col, Image, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { checkViewPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { NavLink, Link, useParams } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import managementActions from "../../../Management/redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { ListTable } from "./ListTable";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { AESEncrypt } from "../../../../../helpers/Crypto";


export default function GoodsReceiptNote(props) {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const prevSearch = usePrevious(search);
    const [sortBy, setSortBy] = useState("createTs");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const timeoutRef = useRef(null);
    //const searchInput = useRef(null);
    let { invoiceOrderID } = useParams();
    const [supplierId, setSupplierId] = useState('');
    const [supplier, setSupplier] = useState({});
    const { history } = props;
    const [loadMore, setLoadMore] = useState(false);
    const [selected, setSelected] = useState([]);

    const [loadMoreContent, setLoadMoreContent] = useState(false);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFillter(supplierId, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    dispatchFillter(supplierId, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);


    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Goods Receipt Note', history, 'Purchase')) {
                loadTasks();
                supplierApi();
            }
        }
        return () => {
            dispatch({ type: managementActions.CLEAR_PURCHASE_MANAGEMENT_DETAILS_START });
        }

    }, [roleManagement]);

    const loadTasks = useCallback(() => {
        dispatchFillter(supplierId, sortBy, sortOrder);
    });

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFillter(supplierId, sortBy, sortOrder, s);
    }

    const dispatchFillter = (supplierId = '', sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (invoiceOrderID) {
            filter['and'].push({ purchaseOrderId: invoiceOrderID });
        }

        if (search) {
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ supplier_name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ supplier_email: { like: '%' + search.trim() + '%' } });
            or['or'].push({ supplier_phone: { like: '%' + search.trim() + '%' } });
            or['or'].push({ deliveryStatus: { like: '%' + search.trim() + '%' } });
        }

        if (supplierId) {
            filter['and'].push({ supplierId: supplierId });
        }

        filter['and'].push(or);
        let f = {
            where: filter,
            order: sortBy + ' ' + sortOrder
        }

        if (!supplierId) {
            f.limit = limit;
            f.skip = skip;
        }

        timeoutRef.current = null;
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'v1/sales-order/purchase-goods',
            skip: skip,
            filter: f
        })
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (invoiceOrderID) {
            filter['and'].push({ purchaseOrderId: invoiceOrderID });
        }

        if (supplierId !== '') {
            filter['and'].push({ supplierId: supplierId });
        }

        if (search !== '') {
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ supplier_name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ supplier_email: { like: '%' + search.trim() + '%' } });
            or['or'].push({ supplier_phone: { like: '%' + search.trim() + '%' } });
            or['or'].push({ deliveryStatus: { like: '%' + search.trim() + '%' } });
        }

        filter['and'].push(or);

        dispatch({
            type: crudActions.EXPORT_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'v1/sales-delivery/goods-receipt',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFillter(supplierId, sortBy, sortOrder);
    }

    const supplierApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: managementActions.SUPPLIER_DETAILS_START, url: 'supplierProfile',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleChangeSupplier = (value) => {
        setSupplierId(value.id);
        setSupplier(value);
        dispatchFillter(value.id, sortBy, sortOrder);
    }

    const handleClick = (e, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };



    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader  {...props} cls={'newImg'}
                img={PurchaseIcon} title={'Purchase'}
                links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Goods Receipt Note', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Goods Receipt Note'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Goods Receipt Note', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Delivery. No., Sup. Name, Sup. Email, Sup. Phone and, Status'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                onChange={(e) => setSearch(e.target.value)}
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'goodReceiptNote', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={clsx(classes.vertiCalScrollOverFlow, classes.customFilterSalesDiscount)}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Goods Receipt Note', 'Action', 'All Supplier') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Suppliers "}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={supplierDetails}
                                                    customClasses={classes.customWidth172P}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    parentValue={customObject(supplierDetails, supplierId)}
                                                    id={idNamingConversion('All Suppliers', 'goodReceiptNote', 'DropDown')}
                                                    searchType={(s) => supplierApi(s)}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            setSupplierId('');
                                                            setSupplier({});
                                                            dispatchFillter('', sortBy, sortOrder);
                                                        }
                                                    }}
                                                    onChange={(data) => handleChangeSupplier(data)}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Goods Receipt Note', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'deliveryNoteHistory', 'Link')}
                                                    onClick={() => { loadImportExportData('DeliveryNoteHistory'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Goods Receipt Note', 'Action', 'Create Invoice') && selected?.length > 0 &&
                                                <Link to={`/sales/transactions/delivery-note/${AESEncrypt(
                                                    {
                                                        name: supplier?.name || '',
                                                        phone: supplier?.mobile || '',
                                                        email: supplier?.email || '',
                                                        deliveryIds: selected,
                                                        single: false
                                                    })}/invoice`} className={clsx(classes.modalBtn, classes.marginRight0)} id={idNamingConversion('CreateInvoice', 'deliveryNoteHistory', 'Link')}>Create Invoice</Link>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                supplierId={supplierId}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadTasks={() => dispatchFillter(supplierId, sortBy, sortOrder)}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                roleManagement={roleManagement}
                                handleClick={(e, id) => handleClick(e, id)}
                                selected={selected}
                                onSelected={(value) => setSelected(value)}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}

                            />
                        </>
                    }
                />
            </div>
        </Fragment>
    )

}